export enum IdentityType {
    Guest,
    UsernamePassword,
    ActiveDirectory,
    OAuth
}
